import { render, staticRenderFns } from "./StepperIndicador.vue?vue&type=template&id=2cfc6143&scoped=true"
import script from "./StepperIndicador.vue?vue&type=script&lang=js"
export * from "./StepperIndicador.vue?vue&type=script&lang=js"
import style0 from "./StepperIndicador.vue?vue&type=style&index=0&id=2cfc6143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc6143",
  null
  
)

export default component.exports